import type { ReactNode, PointerEvent } from "react";

/**
 * A white panel lit from above. A soft pool of teal light follows the
 * pointer on devices that hover.
 */
export function LitPanel({
  children,
  className = "",
  as: Tag = "div",
}: {
  children: ReactNode;
  className?: string;
  as?: "div" | "article" | "li";
}) {
  function onMove(e: PointerEvent<HTMLElement>) {
    if (e.pointerType !== "mouse") return;
    const rect = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mx", `${e.clientX - rect.left}px`);
    e.currentTarget.style.setProperty("--my", `${e.clientY - rect.top}px`);
  }
  return (
    <Tag
      onPointerMove={onMove}
      className={`group/panel relative isolate overflow-hidden rounded-[1.75rem] border border-brand-primary/8 bg-white shadow-lit transition-[box-shadow,translate] duration-500 ease-[var(--ease-out-expo)] hover:-translate-y-1 hover:shadow-lit-lg ${className}`}
    >
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 -z-10 opacity-0 transition-opacity duration-500 group-hover/panel:opacity-100"
        style={{
          background:
            "radial-gradient(420px circle at var(--mx, 50%) var(--my, 0%), rgb(114 181 177 / 0.16), transparent 60%)",
        }}
      />
      {children}
    </Tag>
  );
}
